import React from 'react';
import { Routes, Route, Link } from 'react-router-dom';
import CreateEvent from './pages/CreateEvent';
import EventPage from './pages/EventPage';

function App() {
  return (
    <div className="app">
      <header className="app-header">
        <Link to="/" style={{ textDecoration: 'none' }}>
          <div className="app-logo">
            kranological<span>.events</span>
          </div>
        </Link>
      </header>
      <main>
        <Routes>
          <Route path="/" element={<CreateEvent />} />
          <Route path="/event/:id" element={<EventPage />} />
        </Routes>
      </main>
    </div>
  );
}

export default App;
